import { createRef, useEffect, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import * as actions from "../../stores/actionsList"
import React from "react";
import TaskRow from "./TaskRow";
import moment from 'moment';
// import { calendarFormat } from "moment";
import DailyGanttTable from "./dailyGanttTable";
import YearlyGanttTable from "./yearlyGanttTable";
import MonthlyGanttTable from "./monthlyGanttTable";
import Day from "../views/CalendarDailyView";
import Hours from "./Hours";
import { DragRotateHandler } from "mapbox-gl";
import CustomLoader from "../CustomLoader";
import LoaderButton from "../LoaderButton";
const GantChart = ({
    date,
    weekDaysName,
    setTaskTimestamp,
    inbox,
    nextMonth,
    prevMonth,
    changeTaskTimeStamp,
    setHoveredId,
    windowRect,
    ganttChartView

}) => {
    const MonthsName =
        [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    const cells = [
        {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {},

    ]
    // const [isDisabled, setDisable] = useState(false);
    const [holderWidth, setholderWidth] = useState(null);
    useEffect(() => {
        setTimeout(() => {
            setholderWidth(document.getElementById('gantt').scrollWidth)
        }, 100);
    }, [])
    const ganttref = useRef();
    const _render = () => {
        switch (ganttChartView) {
            case "Day/Hour":
                return (
                    <div className="gantt " id="gantt" style={{ position: 'sticky' ,top:0,zIndex:1   }} ref={ganttref}>
                        {date.map((day, index) => {
                            // let Day = moment().add(index, "days").format("DDD, MMM MM, YYYY");
                            const { dayTitle } = day;
                            return (
                                <div key={index} className="gantt-week w-100" id="gantt-week">
                                    <div className="gantt-week-Title text-smallest">
                                        {dayTitle}
                                    </div>
                                    <Hours />
                                </div>
                            );
                        })}

                        {inbox.desk.map((task, index) => {
                            const { title, _id, timeline } = task;
                            return (
                                <TaskRow
                                    setTaskTimestamp={setTaskTimestamp}
                                    title={title}
                                    holderWidth={holderWidth}
                                    key={_id}
                                    id={_id}
                                    timeline={timeline}
                                    index={index}
                                    date={date}
                                    changeTaskTimeStamp={changeTaskTimeStamp}
                                    setHoveredId={setHoveredId}
                                    windowRect={windowRect}
                                />
                            );
                        })}
                    </div>
                )
            case "Month/Day":
                return (
                    <div className="new"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div className="gantt" id="gantt" style={{ position: 'sticky',top:0,zIndex:1    }} ref={ganttref}>
                            {date.map((month, index) => {
                                const { monthTitle, monthDays,yearTitle } = month;
                                // let month = moment().add(index, "months").format("MMMM,YYYY");

                                return (
                                    <div className="gantt-week" id="gantt-week" style={{ borderRight: "none" }}>
                                        <div className="font-size- text-bold" style={{ padding: "8px 1px", minHeight: "44px" }}>
                                            {monthTitle}
                                        </div>
                                        <div className="gantt-week-Days"
                                            style={{ borderRight: "solid .1px #EBEDF1", borderTop: "solid .1px #EBEDF1" }}
                                        >
                                            {monthDays.map((day, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        id={day.unix()}
                                                        className={"day "}
                                                        style={{ height: "30px", borderRight: "solid .1px #EBEDF1", width: "50px" }}
                                                    >
                                                        <div className="day-number"
                                                            style={{
                                                                border: (day.isSame(new Date(), "day")
                                                                    ? "transparent"
                                                                    : "transparent"),
                                                                backgroundColor: (day.isSame(new Date(), "day")
                                                                    ? ""
                                                                    : "transparent"),
                                                                color: (day.isSame(new Date(), "day")
                                                                    ? "#2b91f0ea"
                                                                    : ""),
                                                                borderRadius: (day.isSame(new Date(), "day")
                                                                    ? ""
                                                                    : ""),
                                                            }}
                                                        >
                                                            {moment().startOf('month').add(index, "days").format('DD')}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <DailyGanttTable />
                                    </div>
                                );
                            })}

                            {inbox.desk.map((task, index) => {
                                const { title, _id, timeline } = task;
                                { console.log(_id, ",", title, "id/title") }
                                return (

                                    <TaskRow
                                        setTaskTimestamp={setTaskTimestamp}
                                        title={title}
                                        holderWidth={holderWidth}
                                        key={_id}
                                        id={_id}
                                        timeline={timeline}
                                        index={index}
                                        date={date}
                                        changeTaskTimeStamp={changeTaskTimeStamp}
                                        setHoveredId={setHoveredId}
                                        windowRect={windowRect}
                                    />
                                );
                            })}
                        </div>
                    </div>
                )
            case "Year/Month":
                return (
                    <div className="new"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div className="gantt" id="gantt" style={{ position: 'sticky',top:0,zIndex:1    }} ref={ganttref}>
                            {date.map((year, index) => {
                                const { yearTitle }=year;
                                return (
                                    <div key={index} className="gantt-week" id="gantt-week">
                                        <div className="gantt-week-Title" >
                                            {yearTitle}
                                        </div>

                                        <div className="flexc" style={{ flexDirection: "row" }}>
                                            {MonthsName.map((month, index) => {
                                                return (
                                                    <div
                                                        className="text-smaller text-center"
                                                        style={{ width: "100px", paddingTop: " 0.1rem" }}
                                                    >{month}</div>
                                                )
                                            })}
                                        </div>
                                        <MonthlyGanttTable />
                                    </div>
                                );
                            })}
                            {inbox.desk.map((task, index) => {
                                const { title, _id, timeline } = task;
                                return (

                                    <TaskRow
                                        setTaskTimestamp={setTaskTimestamp}
                                        title={title}
                                        holderWidth={holderWidth}
                                        key={_id}
                                        id={_id}
                                        timeline={timeline}
                                        index={index}
                                        date={date}
                                        changeTaskTimeStamp={changeTaskTimeStamp}
                                        setHoveredId={setHoveredId}
                                        windowRect={windowRect}
                                    />
                                );
                            })}
                        </div>
                    </div>
                )
            case "Year":
                return (
                    <div className="new"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div className="gantt" id="gantt" style={{ position: 'sticky',top:0,zIndex:1    }} ref={ganttref}>
                            {date.map((year, index) => {
                                const { yearTitle } = year
                                return (
                                    <div key={index} className="gantt-week w-100" id="gantt-week">
                                        {yearTitle}

                                    </div>
                                );
                            })}
                            {inbox.desk.map((task, index) => {
                                const { title, _id, timeline } = task;
                                console.log('task', task)
                                return (

                                    <TaskRow
                                        setTaskTimestamp={setTaskTimestamp}
                                        title={title}
                                        holderWidth={holderWidth}
                                        key={_id}
                                        id={_id}
                                        timeline={timeline}
                                        index={index}
                                        date={date}
                                        changeTaskTimeStamp={changeTaskTimeStamp}
                                        setHoveredId={setHoveredId}
                                        windowRect={windowRect}
                                    />
                                );
                            })}
                        </div>
                        <YearlyGanttTable />
                    </div>
                )
            default:
                return (
                    <div className="new">
                        <div className="gantt" id="gantt" style={{ position: 'sticky',top:0,zIndex:1    }} ref={ganttref}>

                            {date.map((week, index) => {
                                const { weekTitle, weekDays, month } = week;
                                return (
                                    <div key={index} className="gantt-week" id="gantt-week" >
                                        <div className="gantt-week-Title text-smallest">
                                            {weekTitle}
                                        </div>

                                        <div className="weekdays-name">
                                            {weekDaysName.map((wd, index) => {
                                                return <div key={index}>{wd}</div>;
                                            })}
                                        </div>
                                        <div className="gantt-week-Days">
                                            {weekDays.map((day, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        id={day.unix()}
                                                        className={"day "}

                                                    >
                                                        <div className="day-number"
                                                            style={{
                                                                border: (day.isSame(new Date(), "day")
                                                                    ? "transparent"
                                                                    : "transparent"),
                                                                backgroundColor: (day.isSame(new Date(), "day")
                                                                    ? ""
                                                                    : "transparent"),
                                                                color: (day.isSame(new Date(), "day")
                                                                    ? "#2b91f0ea"
                                                                    : ""),
                                                                borderRadius: (day.isSame(new Date(), "day")
                                                                    ? ""
                                                                    : ""),
                                                            }}
                                                        >
                                                            {day.format("D")}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}

                            {inbox.desk.map((task, index) => {
                                const { title, _id, timeline } = task;
                                return (

                                    <TaskRow
                                        setTaskTimestamp={setTaskTimestamp}
                                        title={title}
                                        holderWidth={holderWidth}
                                        key={_id}
                                        id={_id}
                                        timeline={timeline}
                                        index={index}
                                        date={date}
                                        changeTaskTimeStamp={changeTaskTimeStamp}
                                        setHoveredId={setHoveredId}
                                        windowRect={windowRect}
                                    />
                                );
                            })}
                        </div>
                        <div style={{ height: "600px", border: "0.1px solid #EBEDF1", borderBottom: "none", borderTop: "none", display: "flex", flexDirection: "row" }}>

                            {cells.map((cell, index) => {
                                return (

                                    <div className="cell">


                                    </div>
                                )

                            })}
                        </div>
                    </div>

                )
        }
    }
    return (

        <div className="flexcc" >

            <button
                className="h-100 br-6"
                style={{ border: "1px solid gray" }}
                onClick={prevMonth}


            ><p style={{transform:"rotate(-90deg)"}}>last</p></button>
            {_render()}

            <button
                className="h-100 br-6"

                style={{ border: "1px solid gray" }}
                onClick={nextMonth}
            ><p style={{transform:"rotate(90deg)"}}>next</p></button>


        </div>
    )
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GantChart);
